import { useTranslation } from 'react-i18next';
import { Search, ArrowRightLeft, CheckCircle2, Shield } from 'lucide-react';

const AboutPage = () => {
  const { t } = useTranslation();
  const steps = [
    { icon: Search, title: t('about.step1Title'), desc: t('about.step1Desc') },
    { icon: ArrowRightLeft, title: t('about.step2Title'), desc: t('about.step2Desc') },
    { icon: CheckCircle2, title: t('about.step3Title'), desc: t('about.step3Desc') },
  ];

  return (
    <div className="section-container py-10">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-[28px] font-bold text-foreground mb-1">{t('about.title')}</h1>
        <p className="text-[14px] text-muted-foreground mb-12">{t('about.subtitle')}</p>

        <div className="bg-card rounded-[20px] border border-border shadow-[0_1px_3px_0_rgba(0,0,0,0.04),0_4px_12px_0_rgba(0,0,0,0.03)] p-7 mb-10">
          <h2 className="text-[15px] font-bold text-card-foreground mb-3">{t('about.methodology')}</h2>
          <p className="text-[13px] text-muted-foreground leading-relaxed">{t('about.methodologyText')}</p>
        </div>

        <h2 className="text-[15px] font-bold text-foreground mb-6">{t('about.howItWorks')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
          {steps.map((step, i) => (
            <div key={i} className="bg-card rounded-[20px] border border-border shadow-[0_1px_3px_0_rgba(0,0,0,0.04),0_4px_12px_0_rgba(0,0,0,0.03)] p-6 text-center animate-fade-in">
              <div className="mx-auto h-10 w-10 rounded-2xl bg-accent flex items-center justify-center mb-4">
                <step.icon className="h-4.5 w-4.5 text-primary" />
              </div>
              <h3 className="text-[13px] font-bold text-card-foreground mb-1.5">{step.title}</h3>
              <p className="text-[12px] text-muted-foreground leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-card rounded-[20px] border border-border shadow-[0_1px_3px_0_rgba(0,0,0,0.04),0_4px_12px_0_rgba(0,0,0,0.03)] p-7">
          <div className="flex items-center gap-2.5 mb-3">
            <Shield className="h-4.5 w-4.5 text-primary" />
            <h2 className="text-[15px] font-bold text-card-foreground">{t('about.transparency')}</h2>
          </div>
          <p className="text-[13px] text-muted-foreground leading-relaxed">{t('about.transparencyText')}</p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
